import { tabDetailsHandler } from "@redux/TradeLanesProfile/tradeLanesProfileSlice";
import ProfilePanel from "@components/templates/Profile/ProfilePanel/ProfilePanel";
import { tradeLaneTabs, tradeLaneEvents } from "@containers/TradeLanesProfile/utils/enum";
import { renderTradeLanesPanelData } from "@containers/TradeLanesProfile/utils/helpers";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { getEventName, getUserActivePlan } from "@helpers/profileHelper";
import { profileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import { generateTrackingObject } from "@core/global/global-country-functions";

const Panel = () => {
  const { tabDetails, countDetails } = useSelector((state) => state.tradeLanesProfile);
  const { activeTabId } = tabDetails;
  const { loading } = countDetails;
  const [panelData, setPanelData] = useState(tradeLaneTabs);
  const dispatch = useDispatch();
  const { search: searchUrlParams, pathname } = useLocation();
  const dataSource = new URLSearchParams(searchUrlParams).get("dataSource");

  useEffect(() => {
    const filteredPanel = [];
    if (!loading) {
      tradeLaneTabs.map((tab) => {
        if ((tab.countEnum && countDetails[tab.countEnum] > 0) || tab.isExcludeFilter) {
          filteredPanel.push({ ...tab, count: countDetails[tab.countEnum] });
        }
      });
      setPanelData(filteredPanel);
    }
  }, [countDetails, loading]);
  const handlePanelClick = (id) => {
    trademoTrackingEvents(getEventName(profileTypeEnum.tradeLanes, tradeLaneEvents[id].tab), generateTrackingObject(dataSource, pathname, getUserActivePlan()));
    dispatch(
      tabDetailsHandler({
        ...tabDetails,
        activeTabId: id,
      })
    );
  };
  return panelData.length > 0 ? (
    <>
      <ProfilePanel panelData={panelData} handlePanelClick={handlePanelClick} activePanelId={activeTabId} />
      {renderTradeLanesPanelData(activeTabId, countDetails)}
    </>
  ) : null;
};

export default Panel;
